// src/layouts/MainLayout.jsx
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Chatbot from "../components/Chatbot";
import { ScrollProgress, useAutoReveal } from "../utils/motion";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function MainLayout() {
  const { pathname } = useLocation();
  useAutoReveal(pathname);

  return (
    <>
      <ScrollToTop />
      <ScrollProgress />
      <Navbar />
      <div className="app-main">
        <div className="page-transition" key={pathname}>
          <Outlet />
        </div>
      </div>
      <Footer />
      <Chatbot />
    </>
  );
}
